<template>
  <div class="question-box">
    <div class="question-title">
      <span>{{index}}. </span>
      <span class="single-content" v-html="questionContent.content"></span>
      <span class="single-score">({{score}}分)</span>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <i class="divider-line"></i>
    <div class="question-content-option">
      <div class="question-option" v-for="(item,i) in optionsContent" :key="i">
        <el-radio v-model="singleAnswer" :label="i">
          <span class="question-option-sort">{{optionMap[i]}}.</span>
          <span class="question-option-content">
            {{item.content}}
          </span>
        </el-radio>
        <viewer :images="item.file" class="option-img-box">
          <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
    <div v-if="isParsing">
      <i class="divider-line"></i>
      <div class="question-answer true-answer">
        <span>正确答案：</span>
        <span>{{optionMap[analysisContent.answer]}}</span>
      </div>
      <template v-if="analysisContent.content">
        <i class="divider-line"></i>
        <div class="question-analysis">
          <span>答案解析:</span>
          {{analysisContent.content}}
          <viewer :images="analysisContent.file">
            <img v-for="(src,index) in analysisContent.file" :src="src.url" :key="index" class="option-img">
          </viewer>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ["qData", "isParsing", "index"],
  data() {
    return {
      singleAnswer: '',//单选答案
      analysisContent: '',
      questionContent: '',
      optionsContent: '',
      score: '',//单题分数
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H', 8: 'I', 9: 'J',
      },
    }
  },
  mounted() {
    this.analysisContent = this.qData.parsing
    this.questionContent = this.qData.topic_title
    this.optionsContent = this.qData.answer
    this.score = this.qData.score
  }
}
</script>

<style scoped="">
</style>